'use strict';
(() => {
  const data = JSON.parse(document.getElementById('page-data').textContent);
  const navToggle = document.querySelector('.menu-toggle');
  const nav = document.getElementById('mobile-nav');
  navToggle.addEventListener('click', () => {
    const expanded = navToggle.getAttribute('aria-expanded') === 'true';
    navToggle.setAttribute('aria-expanded', String(!expanded)); nav.hidden = expanded;
  });
  nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {nav.hidden = true; navToggle.setAttribute('aria-expanded','false');}));
  const region = document.querySelector('.region-picker');
  document.addEventListener('click', e => {if (!region.contains(e.target)) region.open = false;});
  document.addEventListener('keydown', e => {if (e.key === 'Escape') {region.open = false; nav.hidden = true; navToggle.setAttribute('aria-expanded','false');}});
  document.querySelectorAll('[role="tablist"]').forEach(list => {
    const tabs = [...list.querySelectorAll('[role="tab"]')];
    const activate = (tab, focus = false) => {
      tabs.forEach(t => {
        const active = t === tab;
        t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !active;
      });
      if(focus) tab.focus({preventScroll:true});
      list.dispatchEvent(new CustomEvent('tabchange',{bubbles:true,detail:{id:tab.id}}));
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', e => {
        let n = null;
        if(e.key==='ArrowRight'||(list.getAttribute('aria-orientation')==='vertical'&&e.key==='ArrowDown')) n=(i+1)%tabs.length;
        if(e.key==='ArrowLeft'||(list.getAttribute('aria-orientation')==='vertical'&&e.key==='ArrowUp')) n=(i+tabs.length-1)%tabs.length;
        if(e.key==='Home') n=0;
        if(e.key==='End') n=tabs.length-1;
        if(n!==null){e.preventDefault();activate(tabs[n],true);tabs[n].scrollIntoView({block:'nearest',inline:'nearest'});}
      });
    });
  });
  const dialog = document.getElementById('enquiry-dialog');
  const form = document.getElementById('enquiry-form');
  let opener;
  let selectedDevice = '';
  document.querySelectorAll('[data-enquire]').forEach(button => button.addEventListener('click', () => {
    opener=button;
    const quote=button.dataset.enquire==='quote';
    selectedDevice=button.dataset.deviceName || '';
    const deviceContext=document.getElementById('dialog-device');
    deviceContext.hidden=!selectedDevice;
    deviceContext.textContent=selectedDevice ? `${data.waDevice}: ${selectedDevice}` : '';
    document.getElementById('dialog-title').textContent=quote?data.dialogQuote:data.dialogTitle;
    form.elements.interest.value=quote?'2':selectedDevice?'1':'0';
    dialog.showModal();document.body.classList.add('modal-open');
  }));
  const close = () => dialog.close();
  form.querySelectorAll('a[href$="#enquiry"]').forEach(link => link.addEventListener('click', close));
  document.querySelector('.dialog-close').addEventListener('click',close);
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
  dialog.addEventListener('close',()=>{document.body.classList.remove('modal-open');if(opener)opener.focus({preventScroll:true});});
  form.addEventListener('submit',e=>{
    e.preventDefault();
    if(!form.reportValidity())return;
    const topic=data.interestOptions[Number(form.elements.interest.value)];
    const name=form.elements.name.value.trim();
    if(!name){form.elements.name.focus();return;}
    const notes=form.elements.notes.value.trim();
    const text=`${data.waIntro} ${topic}.\n${data.market}${selectedDevice?'\n'+data.waDevice+': '+selectedDevice:''}\n${data.waName}: ${name}${notes?'\n'+data.waNotes+': '+notes:''}`;
    window.open('https://wa.me/6594468877?text='+encodeURIComponent(text),'_blank','noopener,noreferrer');
  });
})();
